import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isEmpty, sortBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getARReasonCodeSelectionConfig,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { AROpsDetailsSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  DragDropConfigExportTemplate,
  ModalWithItem,
  EmailGroup,
} from '../../../../components/common';
import { tabelColumnExportAROpsDetails, sortAROpsDetails } from '../../constants';
import { getAROpsDetails, getAllAROpsDetails } from '../../actions';
import { makeGetListAROpsDetails, makeGetListAllAROpsDetails } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class AROpsDetails extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listAROpsDetails: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listAROpsDetails: props.listAROpsDetails,
      totalCount: getPageTotalCount({ ...state, items: props.listAROpsDetails }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetArOPSReport },
      getARReasonCodeSelectionConfig,
    } = this.props;
    if (modeGetArOPSReport) {
      this.doGetAROpsDetails();
      this.doGetOutputTemplateByType();
      getARReasonCodeSelectionConfig('', ({ success, data }) => {
        if (success && data) {
          const listReasonOptions = data
            .filter(dt => !!dt.customReasonCode)
            .map(val => {
              return { label: val.customReasonCode, value: val.customReasonCode };
            });
          this.setState({ listReasonOptions: listReasonOptions ? sortBy(listReasonOptions, ['label']) : [] });
        }
      });
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetAROpsDetails();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetAROpsDetails());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetAROpsDetails());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetAROpsDetails();
    });
  };

  doGetAROpsDetails = () => {
    const { filter, page, size, sorted } = this.state;
    const { getAROpsDetails } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortAROpsDetails[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getAROpsDetails(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAllAROpsDetails = cb => {
    const { filter, sorted } = this.state;
    const { getAllAROpsDetails } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortAROpsDetails[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllAROpsDetails(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAllAROpsDetails(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllAROpsDetails, t } = this.props;
        convertJson2Pdf({
          data: listAllAROpsDetails,
          t,
          title: t('reportPage:sidebar.AROpsDetails').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.AROpsDetails')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAllAROpsDetails(() => {
      const { listAllAROpsDetails, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_AROPS_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.AROpsDetails')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.AROpsDetails')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllAROpsDetails,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              arOpsType: 'arOpsType',
              arLevel: 'arLevel',
              taxTreatment: 'taxRule',
              arCrDrType: 'CRDRType',
              accountType: 'accountType',
              paymentMethod: 'paymentMethod',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllAROpsDetails,
          t,
          title: t('reportPage:sidebar.AROpsDetails').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.AROpsDetails')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.AROpsDetails')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('AR_OPS_DETAILS_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportAROpsDetails,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listAROpsDetails,
      listReasonOptions,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllAROpsDetails,
      t,
      permissions: { modeGetArOPSReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetArOPSReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.AROpsDetails') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.AROpsDetails')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <AROpsDetailsSearchForm
                  keyOptionInject="customReason"
                  optionsInject={listReasonOptions}
                  onSubmit={this.onHandleSubmitSearch}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.AROpsDetails').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllAROpsDetails,
                          t,
                          title: t('reportPage:sidebar.AROpsDetails').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.AROpsDetails')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listAROpsDetails}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listAROpsDetails && listAROpsDetails.length ? listAROpsDetails : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

AROpsDetails.propTypes = {
  getAllAROpsDetails: PropTypes.func,
  getAROpsDetails: PropTypes.func,
  listAllAROpsDetails: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

AROpsDetails.defaultProps = {
  getAllAROpsDetails: () => {},
  getAROpsDetails: () => {},
  listAllAROpsDetails: [],
};

const mapStateToProps = createStructuredSelector({
  listAROpsDetails: makeGetListAROpsDetails() || [],
  listAllAROpsDetails: makeGetListAllAROpsDetails() || [],
});

export default withTranslation('common')(
  connect(mapStateToProps, {
    getAROpsDetails,
    getAllAROpsDetails,
    getARReasonCodeSelectionConfig,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(AROpsDetails)
);
